export default {"src":"/_next/static/media/microsoft-small.a7c6a493.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};